
import { useState, useCallback } from "react";

interface TaskFilters {
  priorityFilter: string[];
  actionTypeFilter: string[];
  statusFilter: string[];
  ownerFilter: string[];
  assignedToMe: boolean;
  page: number;
  rowsPerPage: number;
}

const defaultFilters: TaskFilters = {
  priorityFilter: [],
  actionTypeFilter: [],
  statusFilter: [],
  ownerFilter: [],
  assignedToMe: false,
  page: 1,
  rowsPerPage: 10,
};

// Module-level variable to hold the state across page navigations (in-memory)
const filtersStore: Record<string, TaskFilters> = {};

export const useTaskFilter = (projectId?: string) => {
  const key = projectId || "global";

  const [filters, setLocalFilters] = useState<TaskFilters>(
    filtersStore[key] || defaultFilters
  );

  const setFilters = useCallback((newFilters: Partial<TaskFilters>) => {
    setLocalFilters((prev) => {
      const updated = { ...prev, ...newFilters };
      filtersStore[key] = updated; // Sync with global variable
      return updated;
    });
  }, [key]);

  return {
    ...filters,
    setPriorityFilter: (priorityFilter: string[]) => setFilters({ priorityFilter }),
    setActionTypeFilter: (actionTypeFilter: string[]) => setFilters({ actionTypeFilter }),
    setStatusFilter: (statusFilter: string[]) => setFilters({ statusFilter }),
    setOwnerFilter: (ownerFilter: string[]) => setFilters({ ownerFilter }),
    setAssignedToMe: (assignedToMe: boolean) => setFilters({ assignedToMe }),
    setPage: (page: number) => setFilters({ page }),
    setRowsPerPage: (rowsPerPage: number) => setFilters({ rowsPerPage }),
  };
};
